(function () {
  // Autoplay de los videos del grid solo cuando son visibles (ahorra batería/datos)
  var gridVideos = document.querySelectorAll('.vs-card .vs-video');
  if (gridVideos.length) {
    var gridObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.4 });

    gridVideos.forEach(function (video) {
      gridObserver.observe(video);
    });
  }

  var modal = document.getElementById('vs-modal');
  var modalVideo = document.getElementById('vs-modal-video');
  var modalDataWrap = document.getElementById('vs-modal-product-data');
  var modalImageOverlay = document.getElementById('vs-modal-image-overlay');
  var thumbStrip = document.getElementById('vs-thumb-strip');
  var muteToggle = document.getElementById('vs-mute-toggle');
  var selectedOptions = {};
  var currentQty = 1;

  // Refresca el ícono/contador y el drawer del carrito nativo del tema (sin recargar la página)
  function refreshThemeCart(openDrawer) {
    var cartDrawer = document.querySelector('cart-drawer-component');
    var headerWrapper = cartDrawer ? cartDrawer.closest('[id^="shopify-section"]') : null;

    if (!headerWrapper) {
      // Si el tema no usa este componente, al menos refrescamos contadores genéricos por si existen
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    var sectionId = headerWrapper.id.replace('shopify-section-', '');

    fetch(window.location.pathname + '?section_id=' + sectionId)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newWrapper = doc.getElementById(headerWrapper.id);
        if (!newWrapper) return;

        headerWrapper.innerHTML = newWrapper.innerHTML;

        if (openDrawer) {
          var freshDrawer = document.querySelector('cart-drawer-component');
          if (freshDrawer && typeof freshDrawer.open === 'function') {
            freshDrawer.open();
          }
        }
      })
      .catch(function (err) {
        console.error('No se pudo refrescar el carrito', err);
      });
  }

  var muteLabel = document.getElementById('vs-mute-label');

  function toggleMute() {
    modalVideo.muted = !modalVideo.muted;
    muteToggle.querySelector('.vs-icon-muted').hidden = !modalVideo.muted;
    muteToggle.querySelector('.vs-icon-unmuted').hidden = modalVideo.muted;
    muteLabel.textContent = modalVideo.muted ? 'Toca para activar audio' : 'Desactivar';
  }

  muteToggle.addEventListener('click', function (e) {
    e.stopPropagation();
    toggleMute();
  });

  modalVideo.addEventListener('click', function () {
    if (modalVideo.paused) {
      modalVideo.play();
    } else {
      modalVideo.pause();
    }
  });

  function showVideo() {
    modalImageOverlay.hidden = true;
    modalVideo.play().catch(function () {});
  }

  function showImage(src) {
    modalImageOverlay.src = src;
    modalImageOverlay.hidden = false;
    modalVideo.pause();
  }

  function renderThumbs(product, videoPoster) {
    thumbStrip.innerHTML = '';

    // Miniatura para volver al video, con el título del producto encima
    var videoThumbWrap = document.createElement('div');
    videoThumbWrap.classList.add('vs-thumb-video-wrap');

    var videoThumb = document.createElement('img');
    videoThumb.src = videoPoster || (product.images[0] || '');
    videoThumb.alt = 'Video';
    videoThumb.classList.add('is-active');

    var videoThumbLabel = document.createElement('span');
    videoThumbLabel.classList.add('vs-thumb-video-label');
    videoThumbLabel.textContent = product.title;

    videoThumbWrap.addEventListener('click', function () {
      thumbStrip.querySelectorAll('img').forEach(function (i) { i.classList.remove('is-active'); });
      videoThumb.classList.add('is-active');
      showVideo();
    });

    videoThumbWrap.appendChild(videoThumb);
    videoThumbWrap.appendChild(videoThumbLabel);
    thumbStrip.appendChild(videoThumbWrap);

    product.images.forEach(function (imgSrc) {
      var thumb = document.createElement('img');
      thumb.src = imgSrc.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2');
      thumb.alt = product.title;
      thumb.addEventListener('click', function () {
        thumbStrip.querySelectorAll('img').forEach(function (i) { i.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        showImage(imgSrc);
      });
      thumbStrip.appendChild(thumb);
    });
  }

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalImageOverlay.hidden = true;
    modalVideo.muted = true;
    muteToggle.querySelector('.vs-icon-muted').hidden = false;
    muteToggle.querySelector('.vs-icon-unmuted').hidden = true;
    muteLabel.textContent = 'Toca para activar audio';
  }

  document.querySelectorAll('[data-vs-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Click en cada card del grid
  document.querySelectorAll('.vs-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var handle = card.dataset.productHandle;
      var videoEl = card.querySelector('.vs-video');
      var sourceEl = videoEl ? videoEl.querySelector('source') : null;
      var videoSrc = videoEl ? (videoEl.currentSrc || (sourceEl ? sourceEl.src : '')) : '';

      if (!handle) return;

      currentQty = 1;
      selectedOptions = {};

      if (videoSrc) modalVideo.src = videoSrc;
      modalImageOverlay.hidden = true;
      openModal();
      modalVideo.play().catch(function () {});
      modalDataWrap.innerHTML = '<p>Cargando producto...</p>';
      thumbStrip.innerHTML = '';

      fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('No se pudo cargar el producto');
          return res.json();
        })
        .then(function (product) {
          renderProduct(product);
          renderThumbs(product, videoEl ? videoEl.getAttribute('poster') : null);
        })
        .catch(function (err) {
          modalDataWrap.innerHTML = '<p>Error al cargar el producto.</p>';
          console.error(err);
        });
    });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderProduct(product) {
    var html = '';
    html += '<h3>' + product.title + '</h3>';
    html += '<div class="vs-modal-price" id="vs-price">' + formatMoney(product.price) + '</div>';

    product.options.forEach(function (option, index) {
      var optionName = (typeof option === 'string') ? option : option.name;
      var optionKey = 'option' + (index + 1);
      var isColorOption = /color|colour/i.test(optionName);
      var seenValues = [];

      html += '<div class="vs-option-group" data-option-index="' + index + '">';
      html += '<span class="vs-option-label">' + optionName + ' <span class="vs-option-current-value" data-current-value-index="' + index + '"></span></span>';
      html += '<div class="vs-option-values">';

      product.variants.forEach(function (v) {
        var val = v['option' + (index + 1)];
        if (!val || seenValues.indexOf(val) !== -1) return;
        seenValues.push(val);

        if (isColorOption && v.featured_image) {
          html += '<button type="button" class="vs-swatch-btn" data-option-index="' + index + '" data-value="' + val + '" title="' + val + '">' +
            '<img src="' + v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') + '" alt="' + val + '"></button>';
        } else {
          html += '<button type="button" class="vs-option-btn" data-option-index="' + index + '" data-value="' + val + '">' + val + '</button>';
        }
      });

      html += '</div></div>';
    });

    html += '<div class="vs-qty-stepper">' +
      '<button type="button" class="vs-qty-btn" id="vs-qty-minus">&minus;</button>' +
      '<span class="vs-qty-value" id="vs-qty-value">1</span>' +
      '<button type="button" class="vs-qty-btn" id="vs-qty-plus">+</button>' +
      '</div>';

    html += '<hr class="vs-divider">';
    html += '<button type="button" class="vs-add-to-cart" id="vs-add-btn" disabled>Selecciona opciones</button>';
    html += '<button type="button" class="vs-buy-now" id="vs-buy-now-btn" disabled>Comprar ahora</button>';
    html += '<p class="vs-feedback" id="vs-feedback"></p>';

    modalDataWrap.innerHTML = html;

    // Si solo hay 1 variante, se selecciona automáticamente
    if (product.variants.length === 1) {
      product.options.forEach(function (_, index) {
        selectedOptions[index] = product.variants[0]['option' + (index + 1)];
      });
    }

    refreshOptionAvailability(product);
    updateButtons(product);
    updateAddButton(product);

    modalDataWrap.querySelectorAll('.vs-option-btn, .vs-swatch-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.dataset.optionIndex;
        selectedOptions[idx] = btn.dataset.value;
        refreshOptionAvailability(product);
        updateButtons(product);
        updateAddButton(product);
      });
    });

    document.getElementById('vs-qty-minus').addEventListener('click', function () {
      currentQty = Math.max(1, currentQty - 1);
      document.getElementById('vs-qty-value').textContent = currentQty;
    });
    document.getElementById('vs-qty-plus').addEventListener('click', function () {
      currentQty += 1;
      document.getElementById('vs-qty-value').textContent = currentQty;
    });

    document.getElementById('vs-add-btn').addEventListener('click', function () {
      addToCart(product, false);
    });
    document.getElementById('vs-buy-now-btn').addEventListener('click', function () {
      addToCart(product, true);
    });
  }

  function getMatchingVariant(product) {
    var optionCount = product.options.length;
    return product.variants.find(function (v) {
      for (var i = 0; i < optionCount; i++) {
        if (selectedOptions[i] !== v['option' + (i + 1)]) return false;
      }
      return true;
    });
  }

  // Marca como "no disponible" las combinaciones de talla que no existen para el color elegido (y viceversa)
  function refreshOptionAvailability(product) {
    var optionCount = product.options.length;

    modalDataWrap.querySelectorAll('.vs-option-btn, .vs-swatch-btn').forEach(function (btn) {
      var idx = parseInt(btn.dataset.optionIndex, 10);
      var val = btn.dataset.value;

      var testOptions = Object.assign({}, selectedOptions);
      testOptions[idx] = val;

      var exists = product.variants.some(function (v) {
        for (var i = 0; i < optionCount; i++) {
          if (testOptions[i] !== undefined && testOptions[i] !== v['option' + (i + 1)]) return false;
        }
        return true;
      });

      var existsAvailable = product.variants.some(function (v) {
        if (!v.available) return false;
        for (var i = 0; i < optionCount; i++) {
          if (testOptions[i] !== undefined && testOptions[i] !== v['option' + (i + 1)]) return false;
        }
        return true;
      });

      btn.classList.toggle('is-unavailable', exists && !existsAvailable);
    });
  }

  function updateButtons(product) {
    modalDataWrap.querySelectorAll('.vs-option-btn, .vs-swatch-btn').forEach(function (btn) {
      var idx = btn.dataset.optionIndex;
      btn.classList.toggle('is-selected', selectedOptions[idx] === btn.dataset.value);
    });

    modalDataWrap.querySelectorAll('[data-current-value-index]').forEach(function (label) {
      var idx = label.dataset.currentValueIndex;
      label.textContent = selectedOptions[idx] || '';
    });
  }

  function updateAddButton(product) {
    var variant = getMatchingVariant(product);
    var addBtn = document.getElementById('vs-add-btn');
    var buyBtn = document.getElementById('vs-buy-now-btn');
    var priceEl = document.getElementById('vs-price');

    if (variant) {
      priceEl.textContent = formatMoney(variant.price);
      var available = variant.available;
      addBtn.disabled = !available;
      buyBtn.disabled = !available;
      addBtn.textContent = available ? 'Agregar al carrito' : 'Agotado';
      addBtn.dataset.variantId = variant.id;
      buyBtn.dataset.variantId = variant.id;
    } else {
      addBtn.disabled = true;
      buyBtn.disabled = true;
      addBtn.textContent = 'Selecciona opciones';
      delete addBtn.dataset.variantId;
      delete buyBtn.dataset.variantId;
    }
  }

  function addToCart(product, redirectToCheckout) {
    var addBtn = document.getElementById('vs-add-btn');
    var buyBtn = document.getElementById('vs-buy-now-btn');
    var feedback = document.getElementById('vs-feedback');
    var variantId = addBtn.dataset.variantId;

    if (!variantId) return;

    addBtn.classList.add('is-loading');
    addBtn.disabled = true;
    buyBtn.disabled = true;
    feedback.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: currentQty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('No se pudo añadir al carrito');
        return res.json();
      })
      .then(function () {
        if (redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }
        feedback.textContent = 'Producto añadido al carrito ✓';
        feedback.style.color = '#2a7a2a';
        closeModal();
        refreshThemeCart(true);
      })
      .catch(function (err) {
        feedback.textContent = 'Hubo un error, intenta de nuevo.';
        feedback.style.color = '#c0392b';
        console.error(err);
      })
      .finally(function () {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
        buyBtn.disabled = false;
      });
  }
})();